import { executeRequest, Request } from '@jfs/network'
import { ReportTypeEnum } from './../data/models/Settlements'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return response.data.data
}

const generateSettlementReportsReq = (
  tokens: any,
  mid: any,
  _pageNum: any,
  userAccessToken: string,
  isSmid: boolean,
) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getSettlementReportList,
    method: 'POST',
    cache: false,
    body: {
      //mid: mid,
      inputFilter: {
        merchantId: mid,
        reportType: ReportTypeEnum.SETTLEMENT,
        isSMID: isSmid ? 'Y' : 'N',
        responseType: 'ALL',
      },
      configParams: {
        page: _pageNum,
        size: 10,
      },
    },
    headers: {
      Authorization: userAccessToken,
    },
  }
  //console.log('request', request)
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { generateSettlementReportsReq }
